<script>
import store from '../store';
export default {
}
</script>

<template>
    <div class="rp-tips">
        <p>本地最新成交参考价</p>
        <span>提交后可见</span>
    </div>
</template>

<style lang="stylus" scoped>
.rp-tips
    padding 0.4rem 0
    font-size 0
    p
        display inline-block
        margin-right 0.426rem
        vertical-align bottom
        line-height 1.2
        font-size 0.85rem
        color #333
    span
        display inline-block
        vertical-align bottom
        font-size 0.64rem
        color #999
</style>